import { createApiBuilderFromCtpClient } from "@commercetools/platform-sdk";
import {
  ClientBuilder,
  AuthMiddlewareOptions,
  HttpMiddlewareOptions,
} from "@commercetools/sdk-client-v2";
import { nextAppEnv } from "@Utils/environment";

const projectKey = nextAppEnv.commerceTools.authProjectKey;
const scopes = nextAppEnv.commerceTools.authScopes?.split(" ");

// create the authMiddlewareOptions object
const authMiddlewareOptions: AuthMiddlewareOptions = {
  host: nextAppEnv.commerceTools.authUrl,
  projectKey: projectKey,
  credentials: {
    clientId: nextAppEnv.commerceTools.authClientId,
    clientSecret: nextAppEnv.commerceTools.authClientSecret,
  },
  scopes,
  fetch,
};

// create the httpMiddlewareOptions object also
const httpMiddlewareOptions: HttpMiddlewareOptions = {
  host: nextAppEnv.commerceTools.baseUrl,
  fetch,
};

const ctpClient = new ClientBuilder()
  .withProjectKey(projectKey) // not necessary if the projectKey was already passed in the authMiddlewareOptions
  .withClientCredentialsFlow(authMiddlewareOptions)
  .withHttpMiddleware(httpMiddlewareOptions)
  .build();

const apiRoot = createApiBuilderFromCtpClient(ctpClient);
export const callCTP = apiRoot.withProjectKey({ projectKey: projectKey });
